<app-side-menu>
  <div class="item-form-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="cancel()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-box me-3"></i>
                {{ isEditMode ? 'Editar Item' : 'Novo Item' }}
              </h1>
              <p class="page-subtitle">{{ isEditMode ? 'Atualize as informações do item' : 'Cadastre um novo item' }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Formulário -->
    <div class="row">
      <div class="col-12">
        <div class="item-form-card">
          <app-form-shell
            [tabs]="availableTabs"
            [activeTab]="activeTab"
            (tabChange)="selectTab($event)">
          </app-form-shell>

          <!-- Step 1: Informações Básicas -->
          <div *ngIf="currentStep === 1" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-info-circle me-2"></i>
              Informações Básicas
            </h3>
            
            <div [formGroup]="formStep1" class="row g-3">
              <div class="col-md-3">
                <label for="code" class="form-label">Código *</label>
                <input 
                  type="text" 
                  id="code"
                  class="form-control"
                  formControlName="code"
                  [class.is-invalid]="isFieldInvalid('code')"
                  [class.is-valid]="code?.valid"
                  placeholder="Ex: ITM001">
                
                <div class="invalid-feedback" *ngIf="isFieldInvalid('code')">
                  {{ getFieldError('code') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="name" class="form-label">Nome *</label>
                <input 
                  type="text" 
                  id="name"
                  class="form-control"
                  formControlName="name"
                  [class.is-invalid]="isFieldInvalid('name')"
                  [class.is-valid]="name?.valid"
                  placeholder="Nome do item">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('name')">
                  {{ getFieldError('name') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="stockId" class="form-label">Estoque *</label>
                <select 
                  id="stockId"
                  class="form-select"
                  formControlName="stockId"
                  [class.is-invalid]="isFieldInvalid('stockId')">
                  <option value="">Selecione...</option>
                  <option *ngFor="let stock of stocks" [value]="stock.id">
                    {{ stock.name }} ({{ stock.code }})
                  </option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('stockId')">
                  {{ getFieldError('stockId') }}
                </div>
              </div>
              
              <div class="col-md-6">
                <label for="description" class="form-label">Descrição</label>
                <textarea 
                  id="description"
                  class="form-control" 
                  formControlName="description"
                  [class.is-invalid]="isFieldInvalid('description')"
                  rows="3"
                  placeholder="Descrição detalhada do item..."></textarea>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('description')">
                  {{ getFieldError('description') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="warehouseId" class="form-label">Almoxarifado</label>
                <select 
                  id="warehouseId"
                  class="form-select"
                  formControlName="warehouseId">
                  <option value="">Selecione...</option>
                  <option *ngFor="let warehouse of warehouses" [value]="warehouse.id">
                    {{ warehouse.name }} ({{ warehouse.code }})
                  </option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="serialNumber" class="form-label">Número de Série</label>
                <input 
                  type="text" 
                  id="serialNumber"
                  class="form-control"
                  formControlName="serialNumber"
                  placeholder="Ex: SN123456">
              </div>
              
              <div class="col-md-3">
                <label for="batchNumber" class="form-label">Número do Lote</label>
                <input 
                  type="text" 
                  id="batchNumber"
                  class="form-control"
                  formControlName="batchNumber"
                  placeholder="Ex: LOTE001">
              </div>
              
              <div class="col-md-3">
                <label for="manufacturerCode" class="form-label">Código do Fabricante</label>
                <input 
                  type="text" 
                  id="manufacturerCode"
                  class="form-control"
                  formControlName="manufacturerCode"
                  placeholder="Ex: MFG123">
              </div>
              
              <div class="col-md-6">
                <label for="manufacturerName" class="form-label">Nome do Fabricante</label>
                <input 
                  type="text" 
                  id="manufacturerName"
                  class="form-control"
                  formControlName="manufacturerName"
                  placeholder="Nome do fabricante">
              </div>
              
              <div class="col-md-3">
                <label for="model" class="form-label">Modelo</label>
                <input 
                  type="text" 
                  id="model"
                  class="form-control"
                  formControlName="model"
                  placeholder="Ex: Modelo XYZ">
              </div>
              
              <div class="col-md-3">
                <label for="partNumber" class="form-label">Número da Peça</label>
                <input 
                  type="text" 
                  id="partNumber"
                  class="form-control"
                  formControlName="partNumber"
                  placeholder="Ex: PN789">
              </div>
            </div>
          </div>

          <!-- Step 2: Propriedades Físicas -->
          <div *ngIf="currentStep === 2" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-ruler me-2"></i>
              Propriedades Físicas e Localização
            </h3>
            
            <div [formGroup]="formStep2" class="row g-3">
              <div class="col-md-3">
                <label for="unit" class="form-label">Unidade de Medida</label>
                <select 
                  id="unit"
                  class="form-select"
                  formControlName="unit">
                  <option value="">Selecione...</option>
                  <option *ngFor="let unit of units" [value]="unit">{{ unit }}</option>
                </select>
              </div>
              
              <div class="col-md-3">
                <label for="weight" class="form-label">Peso (kg)</label>
                <input 
                  type="number" 
                  id="weight"
                  class="form-control"
                  formControlName="weight"
                  [class.is-invalid]="isFieldInvalid('weight')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('weight')">
                  {{ getFieldError('weight') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="volume" class="form-label">Volume (m³)</label>
                <input 
                  type="number" 
                  id="volume"
                  class="form-control"
                  formControlName="volume"
                  [class.is-invalid]="isFieldInvalid('volume')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('volume')">
                  {{ getFieldError('volume') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="length" class="form-label">Comprimento (cm)</label>
                <input 
                  type="number" 
                  id="length"
                  class="form-control"
                  formControlName="length"
                  [class.is-invalid]="isFieldInvalid('length')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('length')">
                  {{ getFieldError('length') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="width" class="form-label">Largura (cm)</label>
                <input 
                  type="number" 
                  id="width"
                  class="form-control"
                  formControlName="width"
                  [class.is-invalid]="isFieldInvalid('width')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('width')">
                  {{ getFieldError('width') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="height" class="form-label">Altura (cm)</label>
                <input 
                  type="number" 
                  id="height"
                  class="form-control"
                  formControlName="height"
                  [class.is-invalid]="isFieldInvalid('height')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('height')">
                  {{ getFieldError('height') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="color" class="form-label">Cor</label>
                <input 
                  type="text" 
                  id="color"
                  class="form-control"
                  formControlName="color"
                  placeholder="Ex: Azul">
              </div>
              
              <div class="col-md-3">
                <label for="size" class="form-label">Tamanho</label>
                <input 
                  type="text" 
                  id="size"
                  class="form-control"
                  formControlName="size"
                  placeholder="Ex: Grande">
              </div>
              
              <div class="col-md-4">
                <label for="specificLocation" class="form-label">Localização Específica</label>
                <input 
                  type="text" 
                  id="specificLocation"
                  class="form-control"
                  formControlName="specificLocation"
                  placeholder="Ex: Prateleira A1">
              </div>
              
              <div class="col-md-4">
                <label for="shelf" class="form-label">Prateleira</label>
                <input 
                  type="text" 
                  id="shelf"
                  class="form-control"
                  formControlName="shelf"
                  placeholder="Ex: A1">
              </div>
              
              <div class="col-md-4">
                <label for="rack" class="form-label">Estante</label>
                <input 
                  type="text" 
                  id="rack"
                  class="form-control"
                  formControlName="rack"
                  placeholder="Ex: E1">
              </div>
              
              <div class="col-md-12">
                <label for="position" class="form-label">Posição</label>
                <input 
                  type="text" 
                  id="position"
                  class="form-control"
                  formControlName="position"
                  placeholder="Ex: Posição 3, Gaveta 2">
              </div>
            </div>
          </div>

          <!-- Step 3: Controle de Estoque -->
          <div *ngIf="currentStep === 3" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-cubes me-2"></i>
              Controle de Estoque e Financeiro
            </h3>
            
            <div [formGroup]="formStep3" class="row g-3">
              <div class="col-md-3">
                <label for="quantity" class="form-label">Quantidade *</label>
                <input 
                  type="number" 
                  id="quantity"
                  class="form-control"
                  formControlName="quantity"
                  [class.is-invalid]="isFieldInvalid('quantity')"
                  placeholder="0"
                  step="1">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('quantity')">
                  {{ getFieldError('quantity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="minimumQuantity" class="form-label">Quantidade Mínima</label>
                <input 
                  type="number" 
                  id="minimumQuantity"
                  class="form-control"
                  formControlName="minimumQuantity"
                  [class.is-invalid]="isFieldInvalid('minimumQuantity')"
                  placeholder="0"
                  step="1">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('minimumQuantity')">
                  {{ getFieldError('minimumQuantity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="maximumQuantity" class="form-label">Quantidade Máxima</label>
                <input 
                  type="number" 
                  id="maximumQuantity"
                  class="form-control"
                  formControlName="maximumQuantity"
                  [class.is-invalid]="isFieldInvalid('maximumQuantity')"
                  placeholder="0"
                  step="1">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('maximumQuantity')">
                  {{ getFieldError('maximumQuantity') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="currencyCode" class="form-label">Moeda</label>
                <select 
                  id="currencyCode"
                  class="form-select"
                  formControlName="currencyCode">
                  <option *ngFor="let currency of currencyCodes" [value]="currency">{{ currency }}</option>
                </select>
              </div>
              
              <div class="col-md-4">
                <label for="unitCost" class="form-label">Custo Unitário</label>
                <input 
                  type="number" 
                  id="unitCost"
                  class="form-control"
                  formControlName="unitCost"
                  [class.is-invalid]="isFieldInvalid('unitCost')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('unitCost')">
                  {{ getFieldError('unitCost') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="totalCost" class="form-label">Custo Total</label>
                <input 
                  type="number" 
                  id="totalCost"
                  class="form-control"
                  formControlName="totalCost"
                  [class.is-invalid]="isFieldInvalid('totalCost')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('totalCost')">
                  {{ getFieldError('totalCost') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="unitPrice" class="form-label">Preço Unitário</label>
                <input 
                  type="number" 
                  id="unitPrice"
                  class="form-control"
                  formControlName="unitPrice"
                  [class.is-invalid]="isFieldInvalid('unitPrice')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('unitPrice')">
                  {{ getFieldError('unitPrice') }}
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="totalPrice" class="form-label">Preço Total</label>
                <input
                  type="number"
                  id="totalPrice"
                  class="form-control"
                  formControlName="totalPrice"
                  [class.is-invalid]="isFieldInvalid('totalPrice')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('totalPrice')">
                  {{ getFieldError('totalPrice') }}
                </div>
              </div>

              <!-- Novos campos de preço -->
              <div class="col-md-4">
                <label for="costPrice" class="form-label">Preço de Custo</label>
                <input
                  type="number"
                  id="costPrice"
                  class="form-control"
                  formControlName="costPrice"
                  [class.is-invalid]="isFieldInvalid('costPrice')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('costPrice')">
                  {{ getFieldError('costPrice') }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="salePrice" class="form-label">Preço de Venda</label>
                <input
                  type="number"
                  id="salePrice"
                  class="form-control"
                  formControlName="salePrice"
                  [class.is-invalid]="isFieldInvalid('salePrice')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('salePrice')">
                  {{ getFieldError('salePrice') }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="approvalValueLimit" class="form-label">Limite de Aprovação</label>
                <input
                  type="number"
                  id="approvalValueLimit"
                  class="form-control"
                  formControlName="approvalValueLimit"
                  [class.is-invalid]="isFieldInvalid('approvalValueLimit')"
                  placeholder="0.00"
                  step="0.01">
                <div class="invalid-feedback" *ngIf="isFieldInvalid('approvalValueLimit')">
                  {{ getFieldError('approvalValueLimit') }}
                </div>
              </div>

              <div class="col-md-4">
                <label for="requiresApproval" class="form-label">Requer Aprovação</label>
                <div class="form-check">
                  <input
                    type="checkbox"
                    id="requiresApproval"
                    class="form-check-input"
                    formControlName="requiresApproval">
                  <label for="requiresApproval" class="form-check-label">
                    Sim, este item requer aprovação para movimentação
                  </label>
                </div>
              </div>
              
              <div class="col-md-4">
                <label for="manufactureDate" class="form-label">Data de Fabricação</label>
                <input 
                  type="date" 
                  id="manufactureDate"
                  class="form-control"
                  formControlName="manufactureDate">
              </div>
              
              <div class="col-md-4">
                <label for="expirationDate" class="form-label">Data de Vencimento</label>
                <input 
                  type="date" 
                  id="expirationDate"
                  class="form-control"
                  formControlName="expirationDate">
              </div>
              
              <div class="col-md-4">
                <label for="bestBeforeDate" class="form-label">Consumir Preferencialmente</label>
                <input 
                  type="date" 
                  id="bestBeforeDate"
                  class="form-control"
                  formControlName="bestBeforeDate">
              </div>
              
              <div class="col-md-6">
                <label for="qualityStatus" class="form-label">Status de Qualidade</label>
                <select 
                  id="qualityStatus"
                  class="form-select"
                  formControlName="qualityStatus">
                  <option value="">Selecione...</option>
                  <option *ngFor="let status of qualityStatusOptions" [value]="status">{{ status }}</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Step 4: Status e Observações -->
          <div *ngIf="currentStep === 4" class="form-section">
            <h3 class="section-title">
              <i class="fas fa-cogs me-2"></i>
              Status e Observações
            </h3>
            
            <div [formGroup]="formStep4" class="row g-3">
              <div class="col-md-3">
                <label for="status" class="form-label">Status *</label>
                <select 
                  id="status"
                  class="form-select"
                  formControlName="status"
                  [class.is-invalid]="isFieldInvalid('status')">
                  <option *ngFor="let status of statusOptions" [value]="status.name">{{ status.name }}</option>
                </select>
                <div class="invalid-feedback" *ngIf="isFieldInvalid('status')">
                  {{ getFieldError('status') }}
                </div>
              </div>
              
              <div class="col-md-3">
                <label for="condition" class="form-label">Condição</label>
                <select 
                  id="condition"
                  class="form-select"
                  formControlName="condition">
                  <option value="">Selecione...</option>
                  <option *ngFor="let condition of conditionOptions" [value]="condition">{{ condition }}</option>
                </select>
              </div>
              
              <div class="col-md-6">
                <label for="supplierReference" class="form-label">Referência do Fornecedor</label>
                <input 
                  type="text" 
                  id="supplierReference"
                  class="form-control"
                  formControlName="supplierReference"
                  placeholder="Referência do fornecedor">
              </div>
              
              <div class="col-md-6">
                <label for="barcode" class="form-label">Código de Barras</label>
                <input 
                  type="text" 
                  id="barcode"
                  class="form-control"
                  formControlName="barcode"
                  placeholder="Código de barras">
              </div>
              
              <div class="col-md-6">
                <label for="qrCode" class="form-label">QR Code</label>
                <input 
                  type="text" 
                  id="qrCode"
                  class="form-control"
                  formControlName="qrCode"
                  placeholder="QR Code">
              </div>
              
              <div class="col-12">
                <label for="notes" class="form-label">Observações</label>
                <textarea 
                  id="notes"
                  class="form-control" 
                  formControlName="notes"
                  rows="4"
                  placeholder="Observações gerais sobre o item..."></textarea>
              </div>
            </div>

            <h3 class="section-title mt-4">
              <i class="fas fa-toggle-on me-2"></i>
              Configurações
            </h3>
            
            <div [formGroup]="formStep4" class="row g-3">
              <div class="col-md-3">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isActive"
                    class="form-check-input" 
                    formControlName="isActive">
                  <label for="isActive" class="form-check-label">
                    <strong>Ativo</strong>
                  </label>
                </div>
              </div>


              <div class="col-md-3">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isInUse"
                    class="form-check-input" 
                    formControlName="isInUse">
                  <label for="isInUse" class="form-check-label">
                    <strong>Em Uso</strong>
                  </label>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-check">
                  <input 
                    type="checkbox" 
                    id="isDamaged"
                    class="form-check-input" 
                    formControlName="isDamaged">
                  <label for="isDamaged" class="form-check-label">
                    <strong>Danificado</strong>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <!-- Botões de Navegação -->
          <div class="form-actions">
            <div class="d-flex justify-content-between">
              <button 
                type="button"
                class="btn btn-outline-danger"
                (click)="cancel()">
                Cancelar
              </button>
              
              <div>
                <button 
                  type="button"
                  class="btn btn-outline-secondary me-2"
                  (click)="prevStep()"
                  [disabled]="currentStep === 1">
                  <i class="fas fa-arrow-left me-2"></i>
                  Anterior
                </button>
                
                <button 
                  type="button"
                  class="btn btn-primary me-2"
                  (click)="nextStep()"
                  *ngIf="currentStep < 4">
                  Próximo
                  <i class="fas fa-arrow-right ms-2"></i>
                </button>
                
                <button 
                  type="button"
                  class="btn btn-primary"
                  (click)="submit()"
                  [disabled]="isSubmitting || !isAllStepsValid()"
                  *ngIf="currentStep === 4">
                  <i class="fas fa-save me-2" *ngIf="!isSubmitting"></i>
                  <i class="fas fa-spinner fa-spin me-2" *ngIf="isSubmitting"></i>
                  {{ isEditMode ? 'Atualizar' : 'Salvar' }} Item
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
